export default __webpack_public_path__ + "static/media/avatarB2.b8afbe82.png";